import { makeStyles } from '@mui/styles';
import { useIntl } from 'react-intl';
import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useNavigate } from '../../routes';
import { accountSubscriptionManagement } from '../routes';
import { fromAuth, fromTestResultCount, useAppDispatch } from '../../store';

const useStyles = makeStyles(theme => ({
  drawerStyle: {
    margin: theme.spacing(1.5),
    padding: theme.spacing(1),
    flexGrow: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    borderRadius: 6,
    backgroundColor: '#fef9e7',
  },
  textResultsLeft: {
    fontFamily: 'Inter',
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '12px',
    lineHeight: '1.5',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#0009',
  },
  textAvoid: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: '1.5',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#0009',
    marginTop: '8px',
    marginBottom: '16px',
  },
  buttonStyle: {
    backgroundColor: '#f0be0d',
    color: '#22283c',
    fontSize: '14px',
    fontFamily: 'Inter',
    '&:hover': {
      backgroundColor: '#d69f13',
      borderColor: '#d69f13',
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: '#f0be0d',
      borderColor: '#f0be0d',
    },
  },
}));
interface BannerSideBarPros {
  orgId: number,
  accountId?: number,
}
const BannerSideBar = (props: BannerSideBarPros) => {
  const { orgId, accountId } = props;
  const [remainingTestResultsPer, setNemainingTestResultsPer] = useState(100);
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const user = useSelector(fromAuth.selectUser);
  const intl = useIntl();
  const { replace, replaceQuery } = useNavigate();
  const handleClick = () => {
    replace(accountSubscriptionManagement.path, replaceQuery({
      orgId: `${orgId}`,
      accountId: `${accountId}`,
    }));
  };
  const [loading, setLoading] = useState(true);
  const testResultCount = useSelector(fromTestResultCount.selectLatestTestResultCount);
  useEffect(() => {
    const fetchInfo = async () => {
      if (orgId && user) {
        setLoading(true);
        await Promise.all([
          dispatch(fromTestResultCount.doGetLatestTestResultCount(+orgId)),
        ]);
        setLoading(false);
      }
    };
    fetchInfo();
  }, [orgId, user?.email]);
  useEffect(() => {
    if (testResultCount) {
      const { quota, count } = testResultCount;
      const percent = Math.max(Math.round((1 - count / quota) * 100), 0);
      setNemainingTestResultsPer(percent);
    }
  }, [testResultCount]);
  return (
    <>
      {remainingTestResultsPer <= 25 && !loading && (
        <div className={classes.drawerStyle}>
          <span className={classes.textResultsLeft}>
            {intl.formatMessage({ id: 'layout.banners.bannersizebar.testResultLeft' }, { remainingTestResultsPer })}
          </span>
          <span className={classes.textAvoid}>
            {intl.formatMessage({ id: 'layout.banners.bannersizebar.description' }, { br: <br /> })}
          </span>
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handleClick}
            disableRipple={false}
            className={classes.buttonStyle}
          >
            {intl.formatMessage({ id: 'layout.banners.bannersizebar.button' })}
          </Button>
        </div>
      )}
    </>
  );
};

export default BannerSideBar;
